/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 4cac1b9da53da6a27313c951b5242495 */

import { ConcreteRequest } from "relay-runtime";

export type CartRoutesDeleteMutationVariables = {
    checkoutId: string;
    partnerAccountId: string;
};
export type CartRoutesDeleteMutationResponse = {
    readonly digitalRiverCheckoutDelete: {
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
            readonly field: ReadonlyArray<string | null> | null;
        }> | null;
    } | null;
};
export type CartRoutesDeleteMutation = {
    readonly response: CartRoutesDeleteMutationResponse;
    readonly variables: CartRoutesDeleteMutationVariables;
};



/*
mutation CartRoutesDeleteMutation(
  $checkoutId: ID!
  $partnerAccountId: ID!
) {
  digitalRiverCheckoutDelete(digitalRiverCheckoutId: $checkoutId, partnerAccountId: $partnerAccountId) {
    errors {
      message
      field
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "checkoutId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "partnerAccountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "digitalRiverCheckoutId",
        "variableName": "checkoutId"
      },
      {
        "kind": "Variable",
        "name": "partnerAccountId",
        "variableName": "partnerAccountId"
      }
    ],
    "concreteType": "DigitalRiverCheckoutPayload",
    "kind": "LinkedField",
    "name": "digitalRiverCheckoutDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CartRoutesDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CartRoutesDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "4cac1b9da53da6a27313c951b5242495",
    "metadata": {},
    "name": "CartRoutesDeleteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'd78c2250555fa473334a6c2b21be0e58';
export default node;
